import { Button } from '@/components/ui/button';
import { CheckCircle2, PackageCheck } from 'lucide-react';
import { toast } from 'sonner';
import { trpc } from '@/lib/trpc';
import { WinclapLoader } from '@/components/ui/winclap-loader';

interface Props {
  device: { deviceId: string; modelo: string; nroSerie: string; status: string };
  clapperName?: string | null;
}

/**
 * Botón "Entregada" del board de OMs: confirma la entrega física del equipo.
 * Lista para Entregar → Entregado, auditado en DeviceHistory con el email de la OM.
 */
export function ConfirmDeliveryButton({ device, clapperName }: Props) {
  const utils = trpc.useUtils();
  const mutation = trpc.officeManager.confirmDelivery.useMutation({
    onSuccess: (r) => {
      toast.success(
        r.alreadyDelivered
          ? 'Ese equipo ya estaba marcado como entregado'
          : `Entrega registrada: ${device.modelo} (${device.nroSerie})`
      );
      utils.officeManager.getBoard.invalidate();
    },
    onError: (err) => toast.error(err.message),
  });

  if (device.status === 'Entregado') {
    return (
      <span className="inline-flex items-center gap-1 text-xs font-medium text-green-600 dark:text-green-400">
        <CheckCircle2 className="h-3.5 w-3.5" /> Entregada
      </span>
    );
  }

  return (
    <Button
      size="sm"
      variant="outline"
      className="h-7 gap-1.5 border-green-300 text-green-700 hover:bg-green-50 dark:border-green-700 dark:text-green-400"
      disabled={mutation.isPending}
      onClick={() => {
        if (
          window.confirm(
            `¿Confirmás que entregaste ${device.modelo} (${device.nroSerie})${clapperName ? ` a ${clapperName}` : ''}?\n\nEl inventario pasa a "Entregado" y queda registrado quién confirmó.`
          )
        ) {
          mutation.mutate({ deviceId: device.deviceId });
        }
      }}
    >
      {mutation.isPending ? <WinclapLoader size={14} /> : <PackageCheck className="h-3.5 w-3.5" />}
      Entregada
    </Button>
  );
}
